import { c as _c } from "react/compiler-runtime";
import { ToggleButtonGroup as RAC_ToggleButtonGroup } from 'react-aria-components';
import styles from './ToggleButtonGroup.module.css';
import type { ToggleButtonGroupProps } from './ToggleButtonGroup.types';
const ToggleButtonGroup = t0 => {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <RAC_ToggleButtonGroup {...props} className={styles.ToggleButtonGroup} data-test-id="ToggleButtonGroup">{children}</RAC_ToggleButtonGroup>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export { ToggleButtonGroup };